/* eslint-disable no-restricted-globals */
import { Asset } from '@tassat/fred-definitions';
import { Currency } from '@tassat/payments-definitions';
import numeral from 'numeral';

import { formatCurrencyWithDecimal } from './helpers';

export const currencyAsNumber = (amount) => numeral(amount);

export const formatAsCurrency = (
    amount,
    currency?: Pick<Currency, 'AlphabeticCode' | 'Symbol' | 'DecimalPoint'>,
    displayType?: 'symbol' | 'curcode' | undefined
) => {
    if (isNaN(amount)) {
        return amount;
    }

    if (currency !== undefined) {
        const currencyWithDecimal = formatCurrencyWithDecimal(
            amount,
            currency?.DecimalPoint
        );
        if (displayType === 'symbol' || displayType === undefined) {
            return `${currency?.Symbol}${currencyWithDecimal}`;
        }
        if (displayType === 'curcode') {
            return `${currency?.AlphabeticCode} ${currencyWithDecimal}`;
        }
    }

    return numeral(amount)
        .format('$0,.00');
};

export const formatAsAsset = (amount, currency?: Asset, displayType?: 'symbol' | 'curcode' | undefined) => {
    if (isNaN(amount)) {
        return amount;
    }

    if (currency !== undefined) {
        const currencyWithDecimal = formatCurrencyWithDecimal(
            amount,
            currency?.DecimalPoint
        );
        if (displayType === 'symbol' || displayType === undefined) {
            return `${currency?.Symbol}${currencyWithDecimal}`;
        }
        if (displayType === 'curcode') {
            return `${currency?.Curcode} ${currencyWithDecimal}`;
        }
    }

    return numeral(amount)
        .format('$0,.00');
};

export const formatAsCurrencyNoSign = (amount, currency?: Currency) => {
    if (isNaN(amount)) {
        return amount;
    }

    if (currency !== undefined) {
        const currencyWithDecimal = formatCurrencyWithDecimal(
            amount,
            currency?.DecimalPoint
        );

        return `${currencyWithDecimal}`;
    }

    return numeral(amount)
        .format('0,.00');
};

export default formatAsCurrency;